import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { initializeI18n } from './i18nConfigs';

i18n.use(initReactI18next).use(LanguageDetector).use(HttpBackend).init<HttpBackendOptions>(initializeI18n);

export default i18n;
